module.exports = __webpack_public_path__ + "img/moka-satellite.b4e43364.png";